export default __webpack_public_path__ + "static/media/subLogo.6db18dc7.svg";